<template>
  <div class="choose-location-view">
    <div class="mb-3">
      <router-link to="/">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
        {{ $t('navigation.back') }}
      </router-link>
    </div>
    <strong class="text-primary">{{ $t('choose_location.header') }}</strong>
    <div class="location-list mt-3">
      <div v-for="location in locations"
           :key="location.id"
           class="location-item"
      >
        <router-link
          class="location-card"
          :to="['/online-appointment', location.id].join('/')"
        >
          <strong class="d-inline-block pb-2">{{ location.name }}</strong><br>
          {{ location.street }} {{ location.house_number ?? '' }}<br>
          {{ location.postal }} {{ location.city }}<br>
          {{ $t('choose_location.phone', location) }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ChooseLocationView",
  computed: {
    ...mapState({
      locations: state => state.Api.Locations.all,
    }),
  },
}
</script>
